<template>
  <div class="layout-product-tabs">
    <slot></slot>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.layout-product-tabs {
}
</style>
